import * as URLUtils from '@avcan/utils/url'

export function path(stationId) {
    return URLUtils.buildPath('/weather', 'stations', stationId)
}
